import * as React from 'react';

const SvgXCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#56565b"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="x-circle_svg__feather x-circle_svg__feather-x-circle"
    {...props}
  >
    <circle cx={12} cy={12} r={10} />
    <path d="M15 9l-6 6M9 9l6 6" />
  </svg>
);

export default SvgXCircle;
